import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function AnimatedBackground({ backgroundImage }) {
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden -z-20 bg-black">
      {/* Live Animated Full Background Image - Infinite Ken Burns Effect */}
      <AnimatePresence mode="wait">
        <motion.img
          key={backgroundImage}
          src={backgroundImage}
          initial={{ opacity: 0, scale: 1.05 }}
          animate={{ opacity: 0.5, scale: [1.05, 1.15, 1.05] }}
          exit={{ opacity: 0 }}
          transition={{ 
            opacity: { duration: 0.5, ease: "easeInOut" },
            scale: { duration: 30, ease: "linear", repeat: Infinity }
          }}
          className="absolute inset-0 w-full h-full object-cover"
        />
      </AnimatePresence>

      {/* Dark Gradient Overlay for Text Readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80 mix-blend-multiply" />
    </div>
  );
}
